import React from "react";
import MetaComponent from "@/components/common/MetaComponent";
import EditCifOffer from "@/components/editCifOffer";

const metadata = {
  title: "Hubzu | CIF",
};

const EditOffer = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <EditCifOffer />
    </>
  );
};

export default EditOffer;
